import e from "./index.ce.vue.js";
import { defineAndRegisterElement as i } from "../../utils/register-element.js";
const d = i(e);
export {
  d as initReceiveAddress
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/receive-address/index.js
// module id = 1322
// module chunks = 67